import * as React from "react";
import {
  Alert,
  AlertTitle,
  Grid,
  Box,
  CircularProgress,
  Button,
  ButtonGroup,
  Typography,
  Chip,
} from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import ImageListItem from "@mui/material/ImageListItem";
import DressDown from "../items/dress-down.bmp";
import Fruit from "../items/fruit.bmp";
import Candy from "../items/candy.bmp";
import Pizza from "../items/pizza.bmp";
import AirPods from "../items/airpods.bmp";
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  getFirestore,
  collection,
  doc,
  getDocs,
  setDoc,
  where,
  addDoc,
  query,
  updateDoc,
  arrayRemove,
  arrayUnion,
} from "firebase/firestore";
import { RefreshOutlined } from "@mui/icons-material";

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}

export default function AccordionSpendDetails(props) {
  //console.log("props", props);
 //console.log("direct rewards",props.direct_rewards_data)
  const config = {
    apiKey: "AIzaSyDlXuLrebp7QQaX2i7Sagtmi3z-ZLihEbg",
    authDomain: "epic-store-intrinsic.firebaseapp.com",
    projectId: "epic-store-intrinsic",
    storageBucket: "epic-store-intrinsic.appspot.com",
    messagingSenderId: "411861662359",
    appId: "1:411861662359:web:0d9322c8c1093e841007d2",
    measurementId: "G-S9MKBDGDWL",
  };
  const app = initializeApp(config);
  const functions = getFunctions(app);
  const getBalance = httpsCallable(functions, "getPointsBalance");
  const getPurchases = httpsCallable(functions, "getPurchases");
  const getOnlineRewardsBelmont = httpsCallable(
    functions,
    "getOnlineRewardsBelmont"
  );


  const [pointsData, setPointsData] = React.useState([]);
  const [wanted_rewards, set_wanted_rewards] = React.useState([]);
  const [purchased_rewards, set_purchased_rewards] = React.useState([]);
  const [purchases_loading, set_purchases_loading] = React.useState(false);
  const [online_rewards, set_online_rewards] = React.useState([]);
  const [online_rewards_info_loading, set_online_rewards_info_loading] =
    React.useState(false);
  const [online_purchases, set_online_purchases] = React.useState([]);
  const [get_wanted_loading, set_get_wanted_loading] = React.useState(false);
  const [points_earned_loading, set_points_earned_loading] = React.useState(false);
  const [direct_rewards_dressdown_spent, set_direct_rewards_dressdown_spent] = React.useState(0)

  const itemData = [
    {
      img: Fruit,
      cols: 6,
    },
    {
      img: Candy,
      cols: 4,
    },
    {
      img: Pizza,
      cols: 4,
    },
    {
      img: DressDown,
      cols: 3,
    },
    {
      img: AirPods,
      cols: 3,
    },
  ];


  const get_online_purchases = async () => {
    // gets data from spreadsheet
    // getOnlinePurchasesBelmont({
    //   ID: props.student_unique_id
    // })
    // .then((result)=>{
    //   console.log(result.data)
    //   set_online_purchases(result.data)
    // })

    // gets data from firestore
    const db = getFirestore(app);
    const q = query(
      collection(db, "online_purchases"),
      where('timestamp','>',new Date("2024-08-01"))
    )
      //where("student_unique_id", "==", props.student_unique_id)


    const querySnapshot = await getDocs(q);

    const purchases = [];

    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      //console.log(doc.id, doc.data());
      //wanted_rewards.length>0 ? set_wanted_rewards(...wanted_rewards,doc.data()) :
      //console.log("document id",doc.id)
      purchases.push(doc.data());
    });
    //purchases.map((x) => console.log(x.epic_points_spent));
    //purchases.filter((x) => console.log(x.timestamp.toDate().toDateString(),x.timestamp.toDate() >="2024-08-01" ))

    set_online_purchases(purchases)

    //console.log("timestamp filter removed", purchases)

    set_direct_rewards_dressdown_spent(purchases.filter(
      (x) =>
        x.student_unique_id === props.student_unique_id &&
        x.type === 'Dress Down Pass' &&
        x.epic_points_spent === 0 &&
        x.timestamp.toDate() >= new Date("2024-08-01")
    ).length)
  };

  React.useEffect(() => {
    get_online_purchases();
    get_balance();
    //set_wanted_rewards([])
    
  }, []);

  const get_balance = async () => {
    //set_points_earned_loading(true)
    getBalance({
      ID: props.student_unique_id,
    })
      .then((result) => {
        //console.log("spend details", result.data, props.student_unique_id)
        setPointsData(result.data[0] ? result.data[0] : []);
        //set_points_earned_loading(false)
      })
      .catch((err) => {
        console.error(err);
        //set_points_earned_loading(false)
      });
  }

  const get_wanted_rewards = async () => {
    set_get_wanted_loading(true);
    const db = getFirestore(app);
    const q = query(
      collection(db, "wanted_rewards"),
      where("approved", "==", true)
    );

    const querySnapshot = await getDocs(q);
    // set_wanted_rewards([querySnapshot.docs]);

    const rewards = [];

    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      //console.log(doc.id, doc.data());
      //wanted_rewards.length>0 ? set_wanted_rewards(...wanted_rewards,doc.data()) :
      //console.log("document id",doc.id)
      rewards.push(doc.data());
    });
    console.log("how many votes exist?");
    rewards
      .filter(
        (reward) =>
          reward.approved === true &&
          reward.available === false &&
          reward.votes.includes(props.student_unique_id)
      )
      .map((reward) => console.log(reward.name, reward.votes.length));
    set_wanted_rewards(rewards);
    set_get_wanted_loading(false);
  };

  const add_reward = async () => {
    //console.log("add")
    const confirm_yes = props.admin
      ? confirm(
          "Students can submit a request which will be reviewed by the EPIC Store Team"
        )
      : confirm(
          "EPIC Store Team will review your suggestion. Your response will also record your student ID. " +
            props.student_unique_id
        );
    if (confirm_yes) {
      const item_name = prompt(
        "What awesome new reward should be available at the EPIC Store?"
      );
      if (item_name && confirm_yes) {
        const db = getFirestore(app);
        // Add a new document in collection "cities"
        await addDoc(collection(db, "wanted_rewards"), {
          name: item_name,
          approved: false,
          available: false,
          id: props.admin ? "admin" : props.student_unique_id,
          timestamp: new Date(),
          votes: [props.admin ? "admin" : props.student_unique_id],
        });
        alert(
          "Thanks! If your idea is approved by the EPIC Store Team, you will see it as a voting option soon."
        );
      }
    }
  };

  const delete_vote = async (item) => {
    const db = getFirestore(app);
    //const votesRef = doc(db,"wanted_rewards",item)
    //console.log(item)
    const q = query(
      collection(db, "wanted_rewards"),
      where("name", "==", item.name),
      where("approved", "==", true)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(
      (doc) => {
        console.log(doc.ref.id);
        //doc.update({votes:FieldValue.arrayRemove(props.student_unique_id)})
        updateDoc(doc.ref, { votes: arrayRemove(props.student_unique_id) });
      }
      //await setDoc(collection(db,"wanted_rewards",doc()))
    );
    get_wanted_rewards();
  };

  const add_vote = async (item) => {
    const current_votes = wanted_rewards.filter(
      (reward) =>
        reward.approved === true &&
        reward.available === false &&
        reward.votes.includes(props.student_unique_id)
    ).length;

    if (current_votes === 0) {
      const db = getFirestore(app);
      //const votesRef = doc(db,"wanted_rewards",item)
      //console.log(item)
      const q = query(
        collection(db, "wanted_rewards"),
        where("name", "==", item.name),
        where("approved", "==", true)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach(
        (doc) => {
          console.log(doc.ref.id);
          //doc.update({votes:FieldValue.arrayRemove(props.student_unique_id)})
          updateDoc(doc.ref, { votes: arrayUnion(props.student_unique_id) });
        }
        //await setDoc(collection(db,"wanted_rewards",doc()))
      );
      get_wanted_rewards();
    } else {
      alert("You can only vote for one item");
    }
  };

 
  const load_purchases = async () => {
    set_purchases_loading(true);
    getPurchases({
      id: parseInt(props.student_unique_id),
    })
      .then((result) => {
        console.log("purchase details", props.student_unique_id, result.data);
        if (result.data[0].length === 0) {
          console.error(" no purchases ", props.student_unique_id);
        }
        set_purchased_rewards(result.data[0]);
        set_purchases_loading(false);
      })
      .catch((err) => {
        console.error(err);
        set_purchases_loading(false);
      });
  };

  const load_online_rewards = async () => {
    set_online_rewards_info_loading(true);
    
    
      return getOnlineRewardsBelmont({
      id: parseInt(props.student_unique_id),
    })
      .then((result) => {
        console.log("online rewards belmont", result.data);
        const downtown_rewards = [
          [
            "Downtown Book Order",
            "12/20/24",
            "Friday",
            "100",
            "20",
            "",
            "",
            ""
          ]
        ]
        props.studentDataByDay[0].student_reference.school_name ===
        "Downtown" ?  null :
        set_online_rewards(result.data);

        if (result.data[0].length === 0) {
          console.error(" no data ");
          return [];
        }
        set_online_rewards_info_loading(false);
        return props.studentDataByDay[0].student_reference.school_name ===
        "Downtown" ?  null : result.data;
      })
      .catch((err) => {
        console.error(err);
        set_online_rewards_info_loading(false);
        return [];
      });
  };

  const buy_item = async (e, item_details) => {
    get_balance();
    console.log(item_details, parseInt(item_details[5]), item_details[6], props.studentDataByDay[0].student_reference.grade_level)
    console.log(pointsData)
    console.log("points remaining 1", parseInt(pointsData[2]), parseInt(pointsData[3]), parseInt(pointsData[2]))
    console.log("points remaining 2",parseInt(pointsData[2]) - parseInt(pointsData[3]), props.studentDataByDay[0].student_reference.grade_level)
    if (
      parseInt(pointsData[2]) -
        parseInt(pointsData[3]) -
        parseInt(
          online_purchases
            .filter((x) => x.student_unique_id === props.student_unique_id)
            .map((x) => x.epic_points_spent)
            .reduce((partialSum, a) => partialSum + parseInt(a), 0)
        ) <
      item_details[3]
    ) {
      alert(
        `Sorry; this reward requires ${
          item_details[3]
        } points and you only have ${
          parseInt(pointsData[2]) -
          parseInt(pointsData[3]) -
          parseInt(
            online_purchases
              .filter((x) => x.student_unique_id === props.student_unique_id)
              .map((x) => x.epic_points_spent)
              .reduce((partialSum, a) => partialSum + parseInt(a), 0)
          )
        }. If this is an error please report it using the feedback link at the top.`
      );
      return;
    } 
    if (item_details[0].includes('Detention')) {
      console.log(
        "detention pass reward - unserved detentions for this student",
      props.studentDataByDay[0].student_reference
      )
      if((parseInt(props.studentDataByDay[0].student_reference.number_of_detentions_earned) -
      parseInt(props.studentDataByDay[0].student_reference.number_of_detentions_served)
        )<1) {
          alert(
            `Sorry; this reward requires that you have at least 1 unserved detention. 
            But you have ${(parseInt(props.studentDataByDay[0].student_reference.number_of_detentions_earned) -
              parseInt(props.studentDataByDay[0].student_reference.number_of_detentions_served)
                )} unserved detentions. If this is an error please report it using the feedback link at the top.`
          );
          return;
        }
    }
    if (item_details[6]==='Yes') {
      console.log(
        "locked reward - unserved detentions for this student",
      props.studentDataByDay[0].student_reference
      )
      if((parseInt(props.studentDataByDay[0].student_reference.number_of_detentions_earned) -
      parseInt(props.studentDataByDay[0].student_reference.number_of_detentions_served)
        )>1) {
          alert(
            `Sorry; this reward requires that you have no more than 1 unserved detention. But you do not have any unserved detentions. 
            If this is an error please report it using the feedback link at the top.`
          );
        }
        return;
    }
    else {
      if (item_details[5]) {
        if((item_details[5]) === 'MS' && ['9','10','11','12'].includes(props.studentDataByDay[0].student_reference.grade_level)) {
          alert('Sorry this reward is only for middle school students')
          return
        }
        if((item_details[5]) === 'HS' && ['7','8'].includes(props.studentDataByDay[0].student_reference.grade_level)) {
          alert('Sorry this reward is only for high school students')
          return
        }
        if(['7','8','9','10','11','12'].includes((item_details[5])) && (item_details[5]) != props.studentDataByDay[0].student_reference.grade_level) {
          alert('Sorry this reward is not for your grade level')
          return
        }
      }
      if (confirm("Are you sure you want to buy this? There are no refunds")) {
        //re-load load_online_rewards to check for spots (item[4] > item[5])
        return load_online_rewards().then((data) => {
          console.log("data", data, item_details);
          const notes =
            (item_details[0].includes('book') || item_details[0].includes('Book'))
              ? prompt(
                  "What book do you want Intrinsic to buy for you? It must be less than $20. Paste a link to amazon:"
                )
              : 
            ['Intrinsic Sweatshirt (Black)','Intrinsic Polo ','Intrinsic Crewneck'].includes(item_details[0])
              ? prompt(
                  "What size?"
                )
              : "n/a";
          if (!notes && ['Book Order','Book Of Your Choice','Intrinsic Crewneck','Downtown Book Order','Intrinsic Sweatshirt (Black)','Intrinsic Polo '].includes(item_details[0])) {
            alert("No description. Order canceled");
            return;
          }
          //if the spots still exit, add student to list
          console.log("row 0",online_rewards[0],item_details)
          data.map((reward) => {
            if (
              reward[0] === item_details[0] &&
              reward[1] === item_details[1]
            ) {
              if (
                reward[4] >
                online_purchases.filter(
                  (x) => x.type === reward[0] && x.date === reward[1]
                ).length
              ) {
                console.log("proceed", reward);
                const db = getFirestore(app);
                // Add a new document in collection "cities"
                addDoc(collection(db, "online_purchases"), {
                  type: item_details[0],
                  date: item_details[1],
                  epic_points_spent: item_details[3],
                  student_unique_id: props.student_unique_id,
                  timestamp: new Date(),
                  advisor: props.studentDataByDay[0].student_reference.advisors,
                  grade_level:
                    props.studentDataByDay[0].student_reference.grade_level,
                  notes: notes,
                  student_email:
                    props.studentDataByDay[0].student_reference.email,
                });
                get_online_purchases();
                alert("Thanks! You bought a reward!");
              } else {
                alert("Sorry, all spots for this reward are taken");
              }
            }
            //&& reward[1] === item_details[1]
          });
        });
      }
    }
    //alert('this reward has expired')
  };

  const buy_item_with_pass = async (e, item_details) => {
    console.log(item_details, parseInt(item_details[5]), item_details[6], props.studentDataByDay[0].student_reference.grade_level)
    console.log("passes remaining earned, spent",
    props.direct_rewards_dressdown_earned,direct_rewards_dressdown_spent)
    if (props.direct_rewards_dressdown_earned-direct_rewards_dressdown_spent <= 0) {
      alert(
        `Sorry. You don't have any passes. If this is an error please report it using the feedback link at the top.`
      );
      return;
    } 

    else {
      if (item_details[5]) {
        if(parseInt(item_details[5]) != props.studentDataByDay[0].student_reference.grade_level) {
          alert('Sorry this reward is not for your grade level')
          return
        }
      }
      if (confirm("Are you sure you want to buy this? There are no refunds")) {
        //re-load load_online_rewards to check for spots (item[4] > item[5])
        return load_online_rewards().then((data) => {
          console.log("data", data, item_details);
          const notes =
            item_details[0] === "Book Order"
              ? prompt(
                  "What book do you want Intrinsic to buy for you? It must be less than $20. Paste a link to amazon:"
                )
              : "n/a";
          if (!notes && item_details[0] === "Book Order") {
            alert("No description of book. Order canceled");
            return;
          }
          //if the spots still exit, add student to list
          console.log("row 0",online_rewards[0],item_details)
          data.map((reward) => {
            if (
              reward[0] === item_details[0] &&
              reward[1] === item_details[1]
            ) {
              if (
                reward[4] >
                online_purchases.filter(
                  (x) => x.type === reward[0] && x.date === reward[1]
                ).length
              ) {
                console.log("proceed", reward);
                const db = getFirestore(app);
                // Add a new document in collection "cities"
                addDoc(collection(db, "online_purchases"), {
                  type: item_details[0],
                  date: item_details[1],
                  epic_points_spent: 0,
                  student_unique_id: props.student_unique_id,
                  timestamp: new Date(),
                  advisor: props.studentDataByDay[0].student_reference.advisors,
                  grade_level:
                    props.studentDataByDay[0].student_reference.grade_level,
                  notes: notes,
                  student_email:
                    props.studentDataByDay[0].student_reference.email,
                });
                get_online_purchases();
                alert("Thanks! You are on the list!");
              } else {
                alert("Sorry, all spots for this reward are taken");
              }
            }
            //&& reward[1] === item_details[1]
          });
        });
      }
    }
    //alert('this reward has expired')
  };

  return (
    <div>
      <Grid container>
      <Grid item xs={12} md={2}></Grid>
        
        <Grid item xs={12} md={8}>
        {props.studentDataByDay[0].student_reference.school_name ===
        "Downtown" ? (
          <Button
            color="info"
            target="_blank"
            href="https://sites.google.com/intrinsicschools.org/downtown-epic-store"
            variant="outlined"
          >
            Downtown Store Info
          </Button>
        ) : (
          <Button
            color="info"
            target="_blank"
            href="https://sites.google.com/intrinsicschools.org/belmont-epic-store"
            variant="outlined"
          >
            Belmont Store Info
          </Button>
        )}
      <Box m={2} />
        </Grid>

        <Grid item xs={12} md={2}></Grid>

        {
          // points summary
        }
        <Grid item xs={12} md={2}></Grid>
        
        <Grid item xs={12} md={8}>
        <Alert severity="success">
              <AlertTitle>How to Earn Points</AlertTitle>
              You earn 1 point for every log EPIC Points log entry made by staff members in PowerSchool. Track your EPIC Point logs on your student profile in PowerSchool.
              You also earn 10 points every week if you had a good week. Track your good week on your <a href='https://lookerstudio.google.com/u/0/reporting/eeb85444-bc79-4383-bfae-015a29c02bf5' target="_blank" >data report</a>
            </Alert>
            <br/>
          {pointsData.length > 0 ? (
            <Alert severity="info">
              <AlertTitle>Points Earned</AlertTitle>
                { `You earned ${pointsData[2]} points and used ${
                      pointsData[3]
                    } points at the store. You used ${online_purchases
                      .filter(
                        (x) => x.student_unique_id === props.student_unique_id 
                      )
                      .map((x) => x.epic_points_spent)
                      .reduce(
                        (partialSum, a) => partialSum + parseInt(a),
                        0
                      )} points for online purchases. Points remaining: ${
                      parseInt(pointsData[2]) -
                      parseInt(pointsData[3]) -
                      parseInt(
                        online_purchases
                          .filter(
                            (x) =>
                              x.student_unique_id === props.student_unique_id 

                          )
                          .map((x) => x.epic_points_spent)
                          .reduce(
                            (partialSum, a) => partialSum + parseInt(a),
                            0
                          )
                      )
                    } `}
              {purchases_loading ? <CircularProgress /> : null}
              {props.studentDataByDay[0].student_reference.school_name != "Downtown" && 
              pointsData[3] > 0 &&
              purchased_rewards.length === 0 &&
              !purchases_loading ? (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => load_purchases()}
                >
                  Show Purchases
                </Button>
              ) : null}

              {purchased_rewards.length > 0
                ? "You purchased " +
                  purchased_rewards.map((x) => x.Item_Description).length +
                  " rewards including " +
                  [
                    ...new Set(
                      purchased_rewards.map((x) => x.Item_Description)
                    ),
                  ].join(", ")
                : null}
            </Alert>
          ) : (
            <div >
              {points_earned_loading ? <CircularProgress /> : 
              <Button
              variant="outlined"
              onClick={() => get_balance()}>Load Points Earned</Button>
              }
            </div>
          )}
        </Grid>
        <Grid item xs={12} md={2}></Grid>

        {
          // direct rewards
        }
         {<React.Fragment>
          <Grid item xs={12} md={2}></Grid>
          <Grid
            item
            xs={12}
            md={8}
            style={{ alignContent: "center", display: "grid", marginTop: "2em" }}
          >
            {
              <Alert severity="success">
              <AlertTitle>Passes Earned</AlertTitle>
              {props.direct_rewards_data.length == 0 ? `You have not earned any passes yet.` :
              `You earned ${props.direct_rewards_dressdown_earned}
               Dress Down Passes for ${props.direct_rewards_data.map(x=>x.Note).join(', ')} 
               . You used ${direct_rewards_dressdown_spent} passes 
               and have ${props.direct_rewards_dressdown_earned - direct_rewards_dressdown_spent} 
               remaining. All passes expire at the end of the academic year.`}
               <Box m={2}/>
              </Alert>}
            
                  </Grid>
                  <Grid item xs={12} md={2}></Grid>
                  </React.Fragment>
          } 


        {
        // buy an online reward
        }
        <Grid item xs={12} md={2}></Grid>
        <Grid item xs={12} md={8}>
          {online_rewards_info_loading ? (
            <CircularProgress />
          ) : (
            <div >
              <Box m={2} />
              {online_rewards.length === 0 ? (
                props.studentDataByDay[0].student_reference.school_name ===
                "Downtown" ?  null :
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => load_online_rewards()}
                >
                  Buy an Online Reward
                </Button>
              ) : 
              <React.Fragment>
                {
                  // use passes - displays all rewards available for purchase with a pass only and only rewards that are in the future
                  // when i remove the future filter, i get errors
                }
                
                {online_rewards
                  .filter((x)=> x[3] !== '')
                  .filter((x) => x[0] != "Type")
                  .filter((x)=> x[7] === "Yes" )
                  //&&  new Date(x[1]) > new Date())
                  .sort((x, v) => new Date(v[1]) - new Date(x[1]))
                  .map((reward) => {
                  return (
                    online_purchases.filter(
                          (x) =>
                            x.student_unique_id === props.student_unique_id &&
                            x.type === reward[0] &&
                            x.date === reward[1]
                        )[0] ? 
                        <React.Fragment 
                        key={props.student_unique_id+reward[0]+reward[1]}
                        >{reward[0]} - {reward[1]}
                        <Typography
                          variant="h5"
                          color={"orange"}
                          >{`You bought this reward with a pass.` }
                          </Typography>
                          <Box m={2}/>
                          </React.Fragment>
                         : 
                  <React.Fragment>
                      {reward[0]} - {reward[1]}
                      {new Date(reward[1]) < new Date() ? null :
                      <Button
                      variant="outlined"
                      style={{ margin: "3px" }}
                      onClick={(e) => {
                        buy_item_with_pass(e, reward);
                      }}
                    >
                      Use a pass
                    </Button>}<Box m={2}/>
                    </React.Fragment>
                )})
                }
                <Box m={2}/>
                {
                  //use points
                }
                {online_rewards
                  .filter((x)=> x[3] !== '')
                  .filter((x) => x[0] != "Type")
                  .filter((x)=> x[7] != "Yes" )
                  //.filter(x=>parseInt(x[4]) > parseInt(x[5]))
                  .sort((x, v) => new Date(v[1]) - new Date(x[1]))
                  .map((reward) => {
                    return (
                      <p>
                        {reward[0]} - {reward[1]}
                        {online_purchases.filter(
                          (x) =>
                            x.student_unique_id === props.student_unique_id &&
                            x.type === reward[0] &&
                            x.date === reward[1]
                        )[0] ? (
                          <React.Fragment>
                            <Typography
                          variant="h5"
                          color={"orange"}
                          >{`You bought this reward on ${online_purchases.filter(
                            (x) =>
                              x.student_unique_id === props.student_unique_id &&
                              x.type === reward[0] &&
                              x.date === reward[1]
                          ).sort((a,b)=>a.timestamp - b.timestamp)[0].timestamp.toDate().toDateString()
                      } `}
                      </Typography>
                      {new Date(reward[1]) < new Date() || reward[0] == 'Dress Down Pass' 
                        ? null :
                      <Button
                            variant="outlined"
                            style={{ margin: "3px" }}
                            onClick={(e) => {
                              buy_item(e, reward);
                            }}
                          >
                            Buy again for {reward[3]} epic points
                          </Button>}
                      </React.Fragment>
                        ) : 
                        new Date(reward[1]) < new Date() 
                        ?
                        <Typography
                          variant="subtitle2"
                          color={"grey"}
                          >Signup period expired</Typography>
                          : (
                            <React.Fragment>
                              <Typography
                               variant="subtitle2"
                               color={"grey"}
                              >{parseInt(reward[4]) -
                              online_purchases.filter(
                                (x) =>
                                  x.type === reward[0] && x.date === reward[1]
                              ).length}{" "}
                            spots remaining. </Typography>
                          <Button
                            variant="outlined"
                            style={{ margin: "3px" }}
                            onClick={(e) => {
                              buy_item(e, reward);
                            }}
                          >
                            Buy for {reward[3]} epic points
                          </Button>
                          
                          {reward[0] !== 'Dress Down Pass' 
                  || props.direct_rewards_data.length == 0 ? null :
                            // if dress down reward at belmont, all passes
                            <Button
                            variant="outlined"
                            style={{ margin: "3px" }}
                            onClick={(e) => {
                              buy_item_with_pass(e, reward);
                            }}
                          >
                            Use a pass
                          </Button>
                          }
                        </React.Fragment>)}
                      </p>
                    );
                  })}
                  </React.Fragment>
              }
            </div>
          )} 
        </Grid>
  
        <Grid item xs={12} md={2}></Grid>
      </Grid>
      



      {/*
         
        <Grid item xs={12} md={2}></Grid>
        <Grid
          item
          xs={12}
          md={8}
          style={{ alignContent: "center", display: "grid", marginTop: "2em" }}
        >
          {wanted_rewards.length > 0 ? (
            <React.Fragment>
              <Button
                variant="contained"
                color="success"
                onClick={() => add_reward()}
              >
                Suggest a reward
              </Button>
              <Typography variant="subtitle2" style={{ marginTop: "2em" }}>
                or vote below for rewards suggested by others.
                <Button
                  onClick={() => {
                    get_wanted_rewards();
                  }}
                  variant="outlined"
                >
                  <RefreshOutlined />
                </Button>
              </Typography>
              <ul style={{lineHeight:"3"}}>
                {wanted_rewards
                  .filter((reward) => reward.available === false)
                  .sort((a,b)=>a.votes.length - b.votes.length)
                  .map(
                    (reward) => (
                      <li >
                        <Chip label={reward.votes.length + " votes"}/>
                        {reward.name}
                        {props.admin? null :
                          reward.votes.includes(props.student_unique_id) ? (
                            <Chip
                              label={"You voted for this"}
                              onDelete={() => {
                                delete_vote(reward);
                              }}
                            />
                          ) : (
                            <Chip
                              label={"Vote for this"}
                              onClick={() => {
                                add_vote(reward);
                              }}
                            />
                          )
                          //console.log(reward)
                        }
                      </li>
                    )
                    //console.log(reward)
                  )}
              </ul>
              <Typography variant="subtitle2" style={{ marginTop: "2em" }}>
                or visit the store to buy these rewards and many more...
              </Typography>
              <ul >
                {wanted_rewards
                  .filter((reward) => reward.available === true)
                  .map(
                    (reward) => (
                      <li>{reward.name}</li>
                    )
                    //console.log(reward)
                  )}
              </ul>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Typography variant="subtitle2" style={{ marginTop: "2em" }}>
                Visit the store at Belmont or Downtwon campus, or{" "}
              </Typography>
              {get_wanted_loading? <CircularProgress /> :
              <Button
                onClick={() => get_wanted_rewards()}
                variant="contained"
                color="warning"
              >
                Request New Rewards
              </Button>}
            </React.Fragment>
          )}
        </Grid>
        <Grid item xs={12} md={2}></Grid>
        */}

      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        //style={{ minHeight: '100vh' }}
      >
        <ImageList
          style={{ margin: "10%" }}
          //sx={{ width: 600, height: 900 }}
          variant="quilted"
          cols={10}
          //rowHeight={80}
        >
          {itemData.map((item) => (
            <ImageListItem
              key={item.img}
              cols={item.cols || 1}
              rows={item.rows || 1}
            >
              <img
                {...srcset(item.img, 121, item.rows, item.cols)}
                alt={item.title}
                loading="lazy"
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Grid>
      <Box p={2} />
    </div>
  );
}
